import { render, staticRenderFns } from "./TheInbox.vue?vue&type=template&id=9e381b78&"
import script from "./TheInbox.vue?vue&type=script&lang=js&"
export * from "./TheInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports